module.exports = __webpack_public_path__ + "static/media/services2.958e6858.png";